import { render, staticRenderFns } from "./SideTemplate.vue?vue&type=template&id=3a53b382&scoped=true&"
import script from "./SideTemplate.vue?vue&type=script&lang=js&"
export * from "./SideTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SideTemplate.vue?vue&type=style&index=0&id=3a53b382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53b382",
  null
  
)

export default component.exports